module.exports = __webpack_public_path__ + "static/media/landing-banner-m.05d06873.jpg";